import styled from 'styled-components';

export const AccordionWrapper = styled.div`
  display: grid;
  gap: 5px;
  width: 100%;
  overflow: hidden;
`;
export const ReverseAccordionHeader = styled.div`
  display: grid;
  gap: 5px;
  height: 40px;
  background-color: ${({ theme }) => theme.palette.NL0};
  border-radius: 8px;
  display: flex;
  padding: 8px 12px;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
export const AccordionMaxHeightBody = styled.div`
  display: grid;
  max-height: 500px;
  overflow: auto;
`;
export const AccordionOptionsWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
`;
